/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupOrderPostOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID']['input'];
}>;

export type GroupOrderPostOrderQuery = {
  readonly __typename?: 'Query';
  readonly order: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly multipartyDetails: {
      readonly __typename?: 'MultipartyDetail';
      readonly displayName: string;
    } | null;
    readonly currentUserOrderPermissions: {
      readonly __typename?: 'UserOrderPermission';
      readonly isHost: boolean;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly orderParticipant: {
        readonly __typename?: 'OrderParticipant';
        readonly isMe: boolean;
      } | null;
    }>;
    readonly restaurant: { readonly __typename?: 'Restaurant'; readonly isOutpost: boolean };
  };
};

export const GroupOrderPostOrderDocument = gql`
  query GroupOrderPostOrder($orderId: ID!) {
    order(orderId: $orderId) {
      id
      orderType
      orderState
      multipartyDetails {
        displayName
      }
      currentUserOrderPermissions {
        isHost
      }
      lineItems {
        orderParticipant {
          isMe
        }
      }
      restaurant {
        isOutpost
      }
    }
  }
`;

export function useGroupOrderPostOrderQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderPostOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderPostOrderQuery, GroupOrderPostOrderQueryVariables>({
    query: GroupOrderPostOrderDocument,
    ...options,
  });
}
